var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyAndSupplyCloseButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#176B87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66764 23.4504C6.14698 23.9712 6.14706 24.8154 6.6678 25.336C7.18855 25.8567 8.03276 25.8567 8.55342 25.3359L16.0004 17.8876L23.448 25.3352C23.9687 25.8559 24.8129 25.8559 25.3336 25.3352C25.8543 24.8146 25.8543 23.9703 25.3336 23.4496L17.8859 16.0019L25.3331 8.55341C25.8536 8.03266 25.8536 7.18845 25.3328 6.66779C24.8121 6.14713 23.9679 6.14721 23.4472 6.66795L16.0001 14.1163L8.55251 6.66859C8.03182 6.1479 7.18759 6.1479 6.6669 6.66859C6.14619 7.1893 6.14619 8.03351 6.6669 8.55422L14.1148 16.002L6.66764 23.4504Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyAndSupplyCloseButton);
export default __webpack_public_path__ + "static/media/buy-and-supply-close-button.bb287b4e4516daa98c4b6d655f5598ad.svg";
export { ForwardRef as ReactComponent };